import { Form, Input } from "@/atoms"
import {
  isValidSlackWebhookUrl,
  SLACK_CHANNEL_NAME_MAX_LENGTH
} from "@/pages/IntegrationsPage/helpers/slack"

import styles from "./FormSlack.module.scss"

import type { SlackFormValues } from "@/pages/IntegrationsPage/hooks/useSlackAPI.types"
import type { FormSlackProps } from "."

const PREFIX = "integrations.slack.form"
const URL_PLACEHOLDER = "https://hooks.slack.com/services/T…/B…/…"

export const FormSlack = (props: FormSlackProps) => {
  const { form, formId, channel, onFieldsChange, onFinish, t } = props
  const isNew = !channel
  const initialValues: SlackFormValues = { name: channel?.name || "", url: "" }

  return (
    <Form
      className={styles.form}
      form={form}
      id={formId}
      layout="vertical"
      initialValues={initialValues}
      onFieldsChange={onFieldsChange}
      onFinish={onFinish}
    >
      <Form.Item
        label={t(`${PREFIX}.name.label`)}
        name="name"
        required={false}
        rules={[
          {
            required: true,
            whitespace: true,
            message: t("error.requiredField")
          },
          {
            max: SLACK_CHANNEL_NAME_MAX_LENGTH,
            message: t(`${PREFIX}.name.tooLong`, {
              count: SLACK_CHANNEL_NAME_MAX_LENGTH
            })
          }
        ]}
      >
        <Input
          ref={props.focusRef}
          autoComplete="off"
          placeholder={t(`${PREFIX}.name.placeholder`)}
        />
      </Form.Item>
      <Form.Item
        label={t(`${PREFIX}.url.label`)}
        tooltip={t(`${PREFIX}.url.tooltip`)}
        extra={isNew ? undefined : t(`${PREFIX}.url.keep`)}
        name="url"
        required={false}
        rules={[
          { required: isNew, message: t("error.requiredField") },
          {
            validator: (_: unknown, value?: string) =>
              !value?.trim() || isValidSlackWebhookUrl(value)
                ? Promise.resolve()
                : Promise.reject(new Error(t(`${PREFIX}.url.invalid`)))
          }
        ]}
      >
        <Input
          autoComplete="off"
          placeholder={channel?.maskedUrl || URL_PLACEHOLDER}
        />
      </Form.Item>
    </Form>
  )
}
